import { IconBuilder } from "/app/src/components/icons/IconBuilder";

/**
 * Arrow function component that renders an edit button.
 * @param {Object} props - Component props.
 * @param {Function} props.onClick - Function to call on button click.
 * @param {boolean} props.disabled - Flag indicating if the button should be disabled.
 * @returns {JSX.Element} The rendered edit button.
 */
const EditButton = ({
  onClick,
  disabled,
}: {
  onClick: () => void;
  disabled?: boolean;
}) => {
  return (
    <button
      className="bg-none cursor-pointer p-2 border-0 hover:opacity-100"
      onClick={onClick}
      disabled={disabled}
    >
      <IconBuilder icon="Edit" size={20} />
    </button>
  );
};

export default EditButton;
